<template>
  <div class="pm10AvgOver">
    <!-- <img src="static/imgs/pagename/analysisLeft.png" class="prevPage" @click="toPage('')"/>
    <img src="static/imgs/pagename/spotCalendarRight.png" class="nextPage" @click="toPage('spotCalendar')"/> -->
    <div class="line_H">
      <div>小时均值超标统计</div>
    </div>
    <div class="searchTitle">
      <p class="year">2018年</p>
      <p>
        <button v-for="i in month" v-bind:key="i" :class="selectMonth == i?'active':''" @click='changeMonth(i)'>{{i}}</button>
      </p>
      <p class="year">月</p><span class="dan">(单位：小时)</span>
      <div class="subT">
        <button v-for="item in typeList" v-bind:key="item.name" :class="{'active':sensorType == item.name}" @click="search(item.name)" v-html="item.ename"></button>
      </div>
      <span class="search_btn" @click="search()" style="color: #fff;"  v-if="userConfig.platform == 'shenyang'">查询</span>
      <div style="margin-top: 20px;" v-if="userConfig.platform == 'base'">
        <span>省：</span>
        <Select v-model="province" style="width: 150px;" @on-change="provinceChange">
            <Option v-for="item in provinceList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        <span>市：</span>
        <Select v-model="city" style="width: 150px;" @on-change="cityChange">
            <Option v-for="item in cityList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        <span>区：</span>
        <Select v-model="districtId" style="width: 150px;">
            <Option v-for="item in districtList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        <span>类型：</span>
        <Select v-model="monitorAreaType" style="width: 150px;">
            <Option v-for="item in monitorAreaTypeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        <span class="search_btn" @click="search()" style="color: #fff;">查询</span>
      </div>
    </div>
    <div class="charts">
      <el-scrollbar style="height: 100%;">
        <div id="container" class="container"></div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
  const echarts = require("echarts");
  export default {
    data() {
      return {
        userConfig: {},
        myChart: null,
        typeList:[],
        month: "",
        selectMonth:"",
        sensorType:'',
        series: {
          name: [],
          yellowNum: [],
          orangeNum: [],
          redNum: []
        },
        monitorAreaTypeList: [],
        monitorAreaType: "",
        provinceList: [],
        province: "",
        cityList: [],
        city: "",
        districtList: [],
        districtId: 0
      };
    },
    methods: {
      getMonitorStationTypes(){
        this.$http
          .get(this.userConfig.apiName + "/v4/monitorStationTypes")
          .then(response => {
            if(response.data.code == 0){
              let result = response.data.data;
              this.$set(this,'monitorAreaTypeList',result);
              this.$set(this,'monitorAreaType',result[0].id);
            }
          });
      },
      getProvince(){
        this.$http
          .get(this.userConfig.apiName + "/v4/provinces")
          .then(response => {
            if(response.data.code == 0){
              let result = response.data.data;
              this.$set(this,'provinceList',result);
              this.$set(this,'province',result[0].id);
              this.getCity();
            }
          });
      },
      provinceChange() {
        this.getCity();
      },
      getCity(){
        this.$http
          .get(this.userConfig.apiName + "/v4/provinces/" + this.province + "/cities")
          .then(response => {
            if(response.data.code == 0){
              let result = response.data.data;
              this.$set(this,'cityList',result);
              this.$set(this,'city',result[0].id);
              this.getDistrict();
            }
          });
      },
      cityChange() {
        this.getDistrict();
      },
      getDistrict(){
        this.$http
          .get(this.userConfig.apiName + "/v4/cities/" + this.city + "/districts")
          .then(response => {
            if(response.data.code == 0){
              let result = response.data.data;
              this.$set(this,'districtList',result);
              this.$set(this,'districtId',result[0].id);
            }
          });
      },
      getType(){
        this.$http
          .get(this.userConfig.apiName + "/v4/importantSensors")
          .then(response => {
            if(response.data.code == 0){
              let result = response.data.data;
              if(result){
                this.$set(this,'sensorType',result[0].name);
                this.$set(this,'typeList',result);
              }
               let time=setInterval(()=>{
                    if(this.districtId){
                      this.getData();
                      clearInterval(time);
                    }
                  },1000)
            }
          });
      },

      // 初始化图表
      initChart() {
        this.myChart = echarts.init(document.getElementById("container"));
      },

      getData() {
        for (let key in this.series) {
          this.series[key] = [];
        }
        let params = {
          sensorType: this.sensorType,
          month: "2018-" + (this.selectMonth < 9 ? "0" + this.selectMonth : this.selectMonth),
          monitorAreaType: this.monitorAreaType,
          districtId: this.districtId
        };
        if(this.userConfig.platform == "shenyang"){
          params = {
            sensorType: this.sensorType,
            month: "2018-" + (this.selectMonth < 9 ? "0" + this.selectMonth : this.selectMonth)
          };
        }
        this.$http
          .get(this.userConfig.apiName + "/v4/sampleMonitorAnalyze/Excessive", {
            params: params
          })
          .then(response => {
            if(response.data.code == 0){
              let result = response.data.data.content;
              for(let i = result.length; i--; i > 0 || i == 0){
                if(!result[i].yellowNum && !result[i].orangeNum && !result[i].redNum){
                  break;
                }
                this.series.name.push(result[i].name);
                if(result[i].yellowNum){
                  this.series.yellowNum.push(result[i].yellowNum);
                }else{
                  this.series.yellowNum.push("-");
                }
                if(result[i].orangeNum){
                  this.series.orangeNum.push(result[i].orangeNum);
                }else{
                  this.series.orangeNum.push("-");
                }
                if(result[i].redNum){
                  this.series.redNum.push(result[i].redNum);
                }else{
                  this.series.redNum.push("-");
                }
              }

              this.setHeight(this.series.name.length);
              this.setOption();
            }
          });
      },

      // 图表配置选项
      setOption() {
        this.myChart.setOption(this.getOption(), true);
        this.myChart.resize();
      },

      getOption() {
        let option = {
          tooltip: {
            trigger: "axis",
            left: "right",
            axisPointer: {
              type: "shadow"
            },
            formatter: "{b0}<br />超国控点100%: {c0}%<br />超国控点150%: {c1}%<br />超国控点250%: {c2}%"
          },
          legend: {
            left: "center",
            textStyle: {
              color: "#0bfcd7"
            },
            data: ["超国控点100%", "超国控点150%", "超国控点250%"]
          },
          color: ["#44ce18", "#ffaa00", "#f2413b"],
          grid: {
            top: "20",
            left: "20",
            right: "30",
            bottom: '7%',
            containLabel: true
          },
          xAxis: {
            type: "value",
            max: 100,
            position: "bottom",
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                type: "solid",
                color: "#0bfcd7",
                width: "1"
              }
            },
            axisLabel: {
              textStyle: {
                color: "#0bfcd7"
              }
            }
          },
          yAxis: {
            type: "category",
            axisLine: {
              lineStyle: {
                type: "solid",
                color: "#0bfcd7",
                width: "1"
              }
            },
            axisLabel: {
              textStyle: {
                color: "#0bfcd7"
              }
            },
            data: this.series.name
          },
          series: [
            {
              name: "超国控点100%",
              type: "bar",
              stack: "总量",
              barWidth:15,
              label: {
                normal: {
                  show: true,
                  color: "#fff",
                  position: "insideRight",
                  formatter: "{c}%"
                }
              },
              data: this.series.yellowNum
            },
            {
              name: "超国控点150%",
              type: "bar",
              stack: "总量",
              barWidth:15,
              label: {
                normal: {
                  show: true,
                  color: "#fff",
                  position: "insideRight",
                  formatter: "{c}%"
                }
              },
              data: this.series.orangeNum
            },
            {
              name: "超国控点250%",
              type: "bar",
              barWidth:15,
              stack: "总量",
              y: 216.4,
              label: {
                normal: {
                  show: true,
                  color: "#fff",
                  position: "right",
                  formatter: "{c}%"
                }
              },
              data: this.series.redNum
            }
          ]
        };
        return option;
      },

      changeMonth(index) {
        this.selectMonth = index;
        this.search();
      },
      changeType(str){
        this.sensorType = str;
        this.search();
      },
      search(str){
        if(str){
          this.sensorType = str;
        }
        this.getData();
      },

      getMonth() {
        let date = new Date();
        this.$set(this,'month',date.getMonth() + 1);
        this.$set(this,'selectMonth',date.getMonth() + 1);
      },
      setHeight(len){
        let heigh = len*40;
        let el = document.getElementById('container');
        el.style.height = heigh + 'px';
      },
    },
    mounted() {
      this.$set(this,"userConfig",JSON.parse(window.sessionStorage.getItem("userConfig")));
      if(this.userConfig){
        this.getMonitorStationTypes();
        this.getProvince();
        this.getMonth();
        this.initChart();
        this.getType();
      }
    }
  };
</script>

<style scoped lang="less">
  .pm10AvgOver{
    position: absolute;
    top: 1.2rem;
    left: 30px;
    right: 0px;
    width: 100%;
    padding-left: 0.5rem;
    box-sizing: border-box;
    width: 80%;
    margin: auto;
    padding: 20px 20px 50px;
    .prevPage{
      position: absolute;
      top: -60px;
      left: 0px;
      cursor: pointer;
    }
    .nextPage{
      position: absolute;
      top: -60px;
      right: 0px;
      cursor: pointer;
    }
    .line_H{
      color: #0bfcd7;
      font-size: 0.22rem;
      background: #091d3d;
    }
    .searchTitle {
      margin-top: 20px;
      .year{
        background: #091d3d;
        color: #0bfcd7;
        border-radius: 5px;
        padding: 2px 20px;
        margin-top: 3px;
        border: 1px solid #0bfcd7;
      }
      .dan {
        color: #0bfcd7;
        font-size: 0.2rem;
        vertical-align: middle;
        margin-left: 10px;
      }
      p {
        display: inline-block;
        vertical-align: middle;
        color: #f1f1f1;
        &:nth-of-type(1),
        &:nth-of-type(3) {
          font-size: 0.24rem;
        }

        button {
          width: 0.4rem;
          height: 0.4rem;
          font-size: 14px;
          color: #0bfcd7;
          border-radius: 50%;
          background-color: transparent;
          outline: none;
          border: 1px solid #0bfcd7;
          margin: 0px 6px;
          cursor: pointer;
          &.active,
          &:hover {
            background-color: #0bfcd7;
            color:#091d3d;
          }
        }
      }
      .subT {
        display: inline-block;
        padding-top: 5px;
        margin-right: 0.2rem;

        button {
          border: none;
          border-radius: 4px;
          padding: 4px 0.18rem;
          background: #0e2e42;
          color: #0bfcd7;
          outline: none;
          &:hover{
            background: #0d4568;
          }
        }
        .active {
          background: #0d4568;
        }
      }
    }

    .charts {
      width: 100%;
      overflow-y: auto;
      .container {
        width: 90%;
        height: 300px;
        margin: auto;
        margin-top: 20px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/analysis/avgOver.vue